"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, PropSync, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
let ColumnProxy = class extends Mixins(AccountSessionMixins) {
  chooseAdmin() {
    this.$emit("chooseAdmin", this._column);
  }
  get show() {
    if (this._controller.query.filter.group === "vdgroup_system_recycle") {
      return false;
    }
    return true;
  }
};
__decorateClass([
  PropSync("column")
], ColumnProxy.prototype, "_column", 2);
__decorateClass([
  PropSync("controller")
], ColumnProxy.prototype, "_controller", 2);
ColumnProxy = __decorateClass([
  Component({})
], ColumnProxy);
export {
  ColumnProxy as default
};
